import { render, staticRenderFns } from "./receipt-order.vue?vue&type=template&id=d6e957fe&"
import script from "./receipt-order.vue?vue&type=script&lang=js&"
export * from "./receipt-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports